import { render } from "./calendar-input.vue?vue&type=template&id=9af60c60"
import script from "./calendar-input.vue?vue&type=script&lang=js"
export * from "./calendar-input.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__